export default __webpack_public_path__ + "static/media/scrollDown.b3c42543.svg";